// @flow
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Checkbox, Stack } from '@locus-taxy/neo-ui';
import { isEnumControl, or, rankWith, uiTypeIs } from '@jsonforms/core';

import useEnumProps from '../util/useEnumProps';
import sortByOrder from '../util/sortByOrder';

type Props = {};

const EnumCheckboxControl = (props: Props): React.Node => {
    const { t } = useTranslation('platform');

    const {
        data,
        handleChange: onChange,
        path,
        translationKey,
        schema
    } = useEnumProps(props);

    const items = schema?.items?.enum || [];

    const checkedFilters = React.useMemo(() => {
        const filtersMap = {};

        data?.forEach(item => {
            filtersMap[item] = true;
        });

        return filtersMap;
    }, [data]);

    const handleChange = (isChecked: boolean, selectedItem: string) => {
        let updatedFilters;

        // if the value isChecked - true then just add that item to the array of items.
        if (isChecked) {
            updatedFilters = data.concat(selectedItem);
        } else {
            updatedFilters = data.filter(filter => filter !== selectedItem);
        }

        onChange(path, sortByOrder(updatedFilters, items));
    };

    return (
        <Box backgroundColor="white" padding={4} borderRadius="4px">
            <Stack space="xSmall">
                {items.map(item => (
                    <Checkbox
                        key={item}
                        size="medium"
                        label={t(`${translationKey}.values.${item}`)}
                        onChange={value => handleChange(!value, item)}
                        checked={checkedFilters[item]}
                    />
                ))}
            </Stack>
        </Box>
    );
};

export default EnumCheckboxControl;

export const enumCheckboxControlTester: any = rankWith(
    1,
    or(uiTypeIs('EnumCheckboxControl'), isEnumControl)
);
